export default __webpack_public_path__ + "static/media/logo-tender-white.755a8c83.svg";